export const clientArea = {
	title: "Data Hub",
	places: "Places",
	org: "Organization",
	searchPanel: "Panel name",
	noPanels: "No panels available.",
	noPanelsForFilter: "No panel corresponding to applied filters",
	autoRefresh: "Automatic Update.",
	fullScreen: "Full Screen",
	autoUpdatesOn: "Automatic updates turned on",
	autoUpdatesOff: "Automatic updates turned off",
	rotateDevice: "Please rotate your device",
	otherPanels: "Others",
	retrospective: "Year in Review",
	retrospectiveDescription: "View your year retrospective",
	subtitle:
		`Get centralized access to essential data dashboards. ` +
		`Here, you'll find updated insights for analysis and decision-making, all in one place.`,
	panelSelector: {
		title: "Add panels to view",
	},
};
